import { ButtonLinkTypeEnum } from 'common/enums/ButtonLinkEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { usePage } from 'publisher/store'
import { getPageType } from 'publisher/store/page/pageSelectors'
import React from 'react'
import { CommonPublisherLinkButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-link-button-entity-or-sub-entity'
import { OpenUrlActionButtonEntityInterface } from 'src/shared/entities/button/open-url-action-button.schema'
import { OpenUrlWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/open-url-website-button.schema'
import { WebsiteLinkWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/website-link-website-button.schema'

const TEST_ID = 'open-url-button'

export interface OpenUrlButtonProps {
  entity:
    | OpenUrlActionButtonEntityInterface
    | OpenUrlWebsiteActionButtonEntityInterface
    | WebsiteLinkWebsiteActionButtonEntityInterface
}

export const OpenUrlButton = ({ entity }: OpenUrlButtonProps) => {
  const pageType = usePage(getPageType)

  let target: ButtonLinkTypeEnum | '_parent' =
    entity.linkTarget ?? ButtonLinkTypeEnum.openInSameWindow

  if (
    pageType === PageTypeEnum.Lecture &&
    target === ButtonLinkTypeEnum.openInSameWindow
  ) {
    target = '_parent'
  }

  return (
    <CommonPublisherLinkButtonEntityOrSubEntity
      entity={entity}
      dataTestId={TEST_ID}
      href={entity.linkUrl}
      rel={entity.rel}
      target={target}
    />
  )
}
